import { useMutation } from '@apollo/client';

import LearnerObjectUpdateLocale from './LearnerObjectUpdateLocale.graphql';
import type {
  LearnerObject_UpdateLocaleMutation as LearnerObjectUpdateLocaleMutation,
  LearnerObject_UpdateLocaleMutationVariables as LearnerObjectUpdateLocaleMutationVariables,
} from './__generated__/LearnerObjectUpdateLocale';

const useSetUserLocaleMutation = () => {
  const [mutate] = useMutation<LearnerObjectUpdateLocaleMutation, LearnerObjectUpdateLocaleMutationVariables>(
    LearnerObjectUpdateLocale,
    { context: { clientName: 'gatewayGql' } }
  );

  return async (locale: string) => {
    await mutate({
      variables: {
        input: {
          // LearnerObject_UpdateLocale expects a BCP 47 tag (en-US); upstream locale values
          // are underscore-formatted (en_US) for Maestro, so convert back before sending.
          // Uses split/join instead of replace() since replace() with a string (non-regex)
          // argument only replaces the first occurrence, which would silently mishandle
          // any future locale with more than one underscore (e.g. a script-qualified tag).
          locale: locale.split('_').join('-'),
        },
      },
    });
  };
};

export { useSetUserLocaleMutation };
